import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';
import { PasswordFormValue } from '../password-form/password-form.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  token: string | null = null;
  loading = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.error = 'The password reset link is invalid.';
    }
  }

  resetPassword(value: PasswordFormValue): void {
    if (!this.token) {
      this.error = 'The password reset link is invalid.';
      return;
    }

    this.loading = true;
    this.error = '';

    this.authService.resetPassword(this.token, value.newPassword).subscribe({
      next: () => {
        this.loading = false;
        this.toastService.success(
          'Password changed',
          'Your password has been reset successfully. You can now log in.',
        );
        this.router.navigate(['/login']);
      },
      error: (err) => {
        console.error('Could not reset password:', err);
        this.loading = false;
        this.error = 'The reset link is invalid or expired. Please request a new one.';
      },
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
